import React from "react";
import { Card, Spin, Table } from "antd";
import { Icon } from "Components";
import { ColumnsType } from "antd/es/table";
import { MappingChange } from "../Mapping";
import { useTranslation } from "react-i18next";

interface MappingViewTableProps {
    initialData: MappingChange[];
    isLoading: boolean;
}

export const MappingViewTable: React.FC<MappingViewTableProps> = ({
    initialData,
    isLoading
}) => {
    const { t } = useTranslation();

    const columns: ColumnsType<MappingChange> = [
        {
            title: t('mapping.table.status'),
            dataIndex: "action",
            key: "status",
            render: (_: unknown) => {

                return (
                    <span data-slot="badge" className="complete-button">
                        <Icon type="completed" />{t('mapping.reviewProperty.propertyMapping.mapped')}
                    </span>
                );
            },
        },
        {
            title: t('mapping.reviewProperty.propertyMapping.venzaProperty'),
            dataIndex: "venzaProperty",
            key: "venzaProperty",
            render: (_: unknown, record: MappingChange) => {
                return <> {record.venzaProperty}</>
            },
        },
        {
            title: t('mapping.reviewProperty.propertyMapping.pciPortalProperty'),
            dataIndex: "pciPortalProperty",
            key: "pciPortalProperty",
            render: (_: unknown, record: MappingChange) => {
                return <>  {record.pciPortalProperty}</>
            },
        }]
    return (
        <Spin spinning={initialData.length === 0 || isLoading}>
            <div className="bg-white pbx-24"
                style={{
                    minHeight: "100vh",
                    background: "white",
                    padding: "24px"
                }}
            >
                <div className="mapping mw-1200 mx-auto">
                    <Card
                        className="platform-mappings-card"
                        bordered
                    >
                        <Table
                            columns={columns}
                            dataSource={initialData.filter(el => !el?.id?.startsWith("add"))}
                            pagination={false}
                            rowKey="key"
                        />
                    </Card>
                </div>
            </div>
        </Spin>
    );
};
